import { API_URL } from "./axiosSettings";
import { FETCH_CANCEL_MESSAGE } from "../constants/constants";
import { getAuthHeader } from "../helpers/session";
import { convertStreamToJson } from "../util/buffer";
import { logger } from "./logger";

let getDashboardToken, deleteDashboardToken;
const postDashboardToken = {};

export const getDashboard = async (vesselId) => {
  if(!vesselId) return;
  if (typeof getDashboardToken !== typeof undefined) {
    getDashboardToken.abort(FETCH_CANCEL_MESSAGE);
  }

  getDashboardToken = new AbortController();
  try{
    const response = await fetch(`${API_URL}/api/dashboard?vesselId=${vesselId}`, {
      method: "GET",
      headers: getAuthHeader(),
      signal: getDashboardToken.signal,
      responseType: "stream",
    });
    const data = await convertStreamToJson(response.body);

    return { Data: data };
  } catch (e) {
    throw { getDashboard: e };
  }
}

export const postDashboard = async (vesselId, newDashboardData, keepalive = false) => {
  if(!vesselId) return;
  if (typeof postDashboardToken[newDashboardData.id] !== typeof undefined) {
    postDashboardToken[newDashboardData.id].abort(FETCH_CANCEL_MESSAGE);
  }

  postDashboardToken[newDashboardData.id] = new AbortController();
  try {
    const response = await fetch(`${API_URL}/api/dashboard`, {
      method: "POST",
      headers: {...getAuthHeader(), "Content-Type": "application/json"},
      signal: postDashboardToken[newDashboardData.id].signal,
      body: JSON.stringify(newDashboardData),
      keepalive,
    });
    const id = await response.json();
    return { postDashboard: id };
  } catch (e) {
    logger.error({ postDashboard: e });
  }
}

export const deleteDashboard = async (dashboardId) => {
  if(!dashboardId) return;
  if (typeof deleteDashboardToken !== typeof undefined) {
    deleteDashboardToken.abort(FETCH_CANCEL_MESSAGE);
  }
  deleteDashboardToken = new AbortController();

  try {
    const request = await fetch(`${API_URL}/api/dashboard?id=${dashboardId}`, {
      method: 'DELETE',
      headers: getAuthHeader(),
      signal: deleteDashboardToken.signal,
    });
    return { deleteDashboard: request };
  } catch (e) {
    throw { deleteDashboard: e };
  }
}